/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Bir şey yazın…',
  'fabric.editor.editorAssistiveLabel': 'Ana içerik alanı, metin girmek için yazmaya başlayın.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Yardım iletişim kutusunu aç',
};
